import { TOOLBARS } from 'wix-rich-content-editor-common';
import { getDefaultComponentData } from '../types';
import AddImage from '@wix/da-ds/pkg/Icons/24x24/AddImage';
export default (({ helpers, t })=>{
    return [
        {
            type: 'file',
            multi: true,
            name: 'Image',
            tooltip: t('editorToolbar.tooltips.addImage'),
            getIcon: ()=>AddImage,
            componentData: getDefaultComponentData(),
            helpers,
            toolbars: [
                TOOLBARS.FOOTER,
                TOOLBARS.SIDE,
                TOOLBARS.INSERT_PLUGIN
            ],
            t
        }
    ];
});

//# sourceMappingURL=insert-buttons.js.map